import React from 'react'
import '../../../base/Theme.css'
import './Action.css';

const ActionButton = ({style, text, icon, enabled = true, onClick}) => {
    let className = "ActionButton " + style;

    if (!enabled) className += " DisabledActionButton";
    else className += " EnabledActionButton";

    const buildContent = () => {
        if (text) return text;
        if (icon) return icon;
    }

    return (
        <button className={className} onClick={() => {
            onClick();
        }}>{buildContent()}
        </button>
    );
}

export default ActionButton;
